import axios from "../../../../configs/axiosIntereptor";
const BASE_URL = process.env.REACT_APP_BASE_URL;

export const getUserActivity = (
  pagination,
  sort_key,
  sort_type,
  limit,
  filterQueryString // Query string from column filters (e.g., "uuid=value&created_at=2025-11-21")
) => {
  // Build base query parameters
  const baseParams = `page=${pagination}&sSort=${sort_key}&sOrder=${sort_type}&limit=${limit}`;

  // Append column filter query string if it exists
  const fullQuery = filterQueryString && filterQueryString.trim() !== ''
    ? `${baseParams}&${filterQueryString}`
    : baseParams;

  return axios.get(
    `${BASE_URL}/api/billing/active-users?${fullQuery}`
  );
};

export const getVPNAccountDetails = (params) => {
  return axios.get(
    `${BASE_URL}/api/vpn/user-details?sUsername=${params.acc_id}`
  );
};

export const enableDisableVPNAccount = (payload) => {
  return axios.put(`${BASE_URL}/api/vpn/enable-disable`, payload);
};

export const changePassword = (payload) => {
  return axios.put(`${BASE_URL}/api/vpn/change-password`, payload);
};

export const renewVPNUser = (payload) => {
  return axios.put(`${BASE_URL}/api/vpn/renew`, payload);
};

export const updateSubscription = (payload) => {
  return axios.put(`${BASE_URL}/api/vpn/update-subscription`, payload);
};

export const getAccountDedicatedIp = (query) => {
  return axios.get(`${BASE_URL}/api/vpn/get-dedicatedip?sUsername=${query}`);
};

export const releaseDedicatedIp = (payload) => {
  return axios.post(`${BASE_URL}/api/vpn/release-dedicated-ip`, payload);
};

export const deleteVPNAccount = (payload) => {
  return axios.delete(`${BASE_URL}/api/vpn/delete`, {data: payload});
};

export const assignDedicatedIp = (payload) => {
  return axios.post(`${BASE_URL}/api/vpn/assign-dedicated-ip`, payload);
};

export const getLogs = (query) => {
  const params = new URLSearchParams(query).toString();
  return axios.get(`${BASE_URL}/api/dashboard/vpn-logs?${params}`);
};

export const getAllLogs = (query) => {
  const params = new URLSearchParams(query).toString();
  return axios.get(`${BASE_URL}/api/dashboard/all-logs?${params}`);
};

// Get list of exported VPN user files
export const exportVpnList = () => {
  return axios.get(`${BASE_URL}/api/vpn/exportVpnList`);
};

// Get download URL for a VPN user export file
export const getVpnUserDownloadUrl = (resellerId, filename) => {
  const url = `${BASE_URL}/api/vpn/downloadVpnUsers`;
  return axios.post(url, {
    filename,
  });
};
